import axiosService from 'services/axiosService';
import { DOMAIN } from 'constants';
const url = 'api/v2/nutritions';

export const trainingData = params => {
  return axiosService.post(`${DOMAIN}/${url}/unauthenticat_ai_auto`, params.formData);
};
